import React from 'react';
import {startGoogleLogin, startYandexLogin} from '../../http/userAPI';
import yandexIcon from '../../assets/Yandex_icon.svg-2.png';

/** Одинаковая область под иконку (внешний квадрат + внутренний контент одной стороны). */
function OAuthIconSlot({children}) {
    return (
        <span className="flex h-8 w-8 shrink-0 flex-none items-center justify-center [min-width:2rem] [min-height:2rem]">
            {children}
        </span>
    );
}

/** «G» визуально крупнее при тех же px — чуть меньше, чем слот Яндекса. */
const INNER_GOOGLE = 'block h-5 w-5 max-h-[1.25rem] max-w-[1.25rem]';
const INNER_YANDEX = 'block h-7 w-7 max-h-[1.75rem] max-w-[1.75rem]';

/** Официальная многоцветная «G» (сжато под малый размер). */
function GoogleMark() {
    return (
        <OAuthIconSlot>
            <svg className={INNER_GOOGLE} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
                <path
                    fill="#EA4335"
                    d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                />
                <path
                    fill="#4285F4"
                    d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.56 2.93-2.25 5.41-4.78 7.07l7.73 6c4.51-4.18 7.09-10.36 7.09-17.54z"
                />
                <path
                    fill="#FBBC05"
                    d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                />
                <path
                    fill="#34A853"
                    d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                />
                <path fill="none" d="M0 0h48v48H0z" />
            </svg>
        </OAuthIconSlot>
    );
}

function YandexMark() {
    return (
        <OAuthIconSlot>
            <img
                src={yandexIcon}
                alt=""
                className={`${INNER_YANDEX} object-contain`}
                draggable={false}
            />
        </OAuthIconSlot>
    );
}

/**
 * Кнопки OAuth в духе брендов провайдеров и палитры витрины (скругления, тени).
 * @param {{ google?: boolean, yandex?: boolean }} props
 */
export default function OAuthProviderButtons({google, yandex}) {
    if (!google && !yandex) {
        return null;
    }

    const onYandex = async () => {
        try {
            await startYandexLogin();
        } catch (e) {
            const st = e.response?.status;
            if (st === 404) {
                window.alert('Вход через Яндекс на этом сервере не настроен.');
            } else {
                window.alert(e.response?.data?.message || 'Не удалось начать вход через Яндекс');
            }
        }
    };

    const oauthBtnClass =
        'flex h-12 min-h-12 w-full items-center justify-center gap-3 rounded-2xl px-4 text-sm shadow-sm transition active:scale-[0.99]';

    return (
        <div className="mt-6 w-full border-t border-stone-200/80 pt-6">
            <div className="flex flex-col gap-3">
                {google ? (
                    <button
                        type="button"
                        onClick={startGoogleLogin}
                        className={`${oauthBtnClass} border border-stone-300/90 bg-white font-medium text-bark-800 hover:bg-cream-50`}
                    >
                        <GoogleMark />
                        <span className="leading-none">Войти через Google</span>
                    </button>
                ) : null}
                {yandex ? (
                    <button
                        type="button"
                        onClick={onYandex}
                        className={`${oauthBtnClass} border border-black/10 bg-[#111] font-semibold text-white hover:bg-black`}
                    >
                        <YandexMark />
                        <span className="leading-none">Войти через Яндекс</span>
                    </button>
                ) : null}
            </div>
        </div>
    );
}
